import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-amber-50 to-sky-50 flex flex-col">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-xl font-bold text-blue-800">← Späť</Link>
            <div className="text-gray-600">Terms of Service</div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-md shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Terms of Service
          </h1>
          
          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">1. Agreement to Terms</h2>
              <p className="leading-relaxed">
                By accessing and using this website and purchasing our ebook "Finančný Pokoj", 
                you agree to be bound by these Terms of Service and all applicable laws and regulations. 
                If you do not agree with any of these terms, you are prohibited from using or accessing this site.
              </p>
              <p className="leading-relaxed mt-3">
                These Terms of Service are entered into between you and <strong>Wavelyne SINGLE MEMBER P.C.</strong>, 
                a company registered at Leof. Andrea Siggrou 196, Kallithea 176 71, Athens, Greece 
                (VAT: EL802952696), hereinafter referred to as "the Company", "we", "us", or "our".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">2. Description of Service</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Our service provides digital content in the form of an ebook titled "Finančný Pokoj" 
                  (also known as "Ked peniaze prestanu strasit") available in multiple formats including PDF, EPUB, and MOBI.
                </p>
                <p className="leading-relaxed">
                  The ebook contains financial guidance and educational materials designed to help users 
                  improve their financial management skills and achieve financial peace of mind.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">3. Payment Terms</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  The ebook is offered at a one-time payment of 5.99 EUR. Payment is processed securely 
                  through Viva Wallet, our authorized payment processor.
                </p>
                <p className="leading-relaxed">
                  All payments are final. Upon successful payment, you will receive immediate access 
                  to download the ebook in your chosen format(s).
                </p>
                <p className="leading-relaxed">
                  We offer a 14-day money-back guarantee. If you are not satisfied with the ebook, 
                  you may request a full refund within 14 days of purchase.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">4. Digital Product Terms</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Upon purchase, you receive a personal, non-transferable license to use the ebook 
                  for your personal use only.
                </p>
                <p className="leading-relaxed">
                  You may not reproduce, distribute, modify, create derivative works, publicly display, 
                  publicly perform, publish, or sell any portion of the ebook.
                </p>
                <p className="leading-relaxed">
                  You may make one (1) backup copy of the ebook for personal use only.
                </p>
                <p className="leading-relaxed">
                  The ebook is protected by copyright and other intellectual property laws. 
                  Unauthorized use may violate copyright, trademark, and other laws.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">5. Refund Policy</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  We offer a 14-day money-back guarantee from the date of purchase. 
                  To request a refund, contact us within 14 days of your purchase with 
                  your order details and reason for the refund request.
                </p>
                <p className="leading-relaxed">
                  Refunds will be processed within 5-7 business days of approval. 
                  The refund will be issued to the original payment method.
                </p>
                <p className="leading-relaxed">
                  After the 14-day period, all sales are final and no refunds will be issued.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">6. Limitation of Liability</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  The information provided in this ebook is for educational purposes only. 
                  We are not financial advisors, accountants, or legal professionals.
                </p>
                <p className="leading-relaxed">
                  We make no guarantees regarding the effectiveness of the financial strategies 
                  presented in the ebook. Individual results may vary based on personal circumstances.
                </p>
                <p className="leading-relaxed">
                  In no event shall we be liable for any direct, indirect, incidental, special, 
                  or consequential damages arising out of or in connection with the use of this ebook.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">7. Privacy Policy</h2>
              <p className="leading-relaxed">
                Your privacy is important to us. Please review our Privacy Policy, which also governs 
                your use of this service, to understand our practices. By using this service, you agree 
                to the collection and use of information in accordance with our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">8. Termination</h2>
              <p className="leading-relaxed">
                We may terminate or suspend your access immediately, without prior notice or liability, 
                for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">9. Governing Law</h2>
              <p className="leading-relaxed">
                These Terms shall be interpreted and governed by the laws of the Slovak Republic, 
                without regard to its conflict of law provisions. Any disputes arising from these terms 
                shall be resolved in the courts of Slovakia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">10. Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these Terms at any time. If we make material changes, 
                we will notify you by email or by posting a notice on our site prior to the effective 
                date of the changes. Your continued use of the service after such modifications constitutes 
                acceptance of the updated Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-800 mb-4">11. Contact Information</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  If you have any questions about these Terms, please contact us:
                </p>
                <div className="bg-gray-50 rounded-md p-4">
                  <p className="font-semibold">Wavelyne SINGLE MEMBER P.C.</p>
                  <p>Leof. Andrea Siggrou 196</p>
                  <p>Kallithea 176 71, Athens, Greece</p>
                  <p>VAT: EL802952696</p>
                  <p className="mt-2">Email: <a href="mailto:diana@wavelynecode.com" className="text-blue-600 hover:underline">diana@wavelynecode.com</a></p>
                </div>
              </div>
            </section>

            <div className="mt-12 p-6 bg-gradient-to-r from-amber-50 to-blue-50 rounded-md border border-amber-200">
              <p className="text-sm text-gray-600 text-center">
                These Terms of Service were last updated on January 1, 2024 and are effective 
                as of the date of your first purchase or use of our service.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
